import React, { useState, useEffect } from 'react';
import emailjs from 'emailjs-com';
import { Layout } from '../../components';
import { Link, Button, Element, Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll'
import "./Contact.scss";

const initialState = {
    name: '',
    email: '',
    message: '',
}

const Contact = (props) => {
    const [{ name, email, message }, setState] = useState(initialState)

    const handleChange = (e) => {
        const { name, value } = e.target
        setState((prevState) => ({ ...prevState, [name]: value }))
    }
    const clearState = () => setState({ ...initialState })

    useEffect(() => {
        scroll.scrollToTop();
    }, [])

    const handleSubmit = (e) => {
        e.preventDefault()
        console.log(name, email, message)
        emailjs
            .sendForm(
                'YOUR_SERVICE_ID', 'YOUR_TEMPLATE_ID', e.target, 'YOUR_USER_ID'
            )
            .then(
                (result) => {
                    console.log(result.text)
                    clearState()
                },
                (error) => {
                    console.log(error.text)
                }
            )
    }
    return (
        <Layout background="#1f2024">
            <div>
                <div className="prestadores__promotion">
                    Dejanos tu mensaje!
                </div>
                <div id='contact'>

                    <div className='container'>

                        <div className='row'>
                            <div className='section-title'>
                                <h2 className="title">Contactanos</h2>
                                <p>
                                    Si necesitas contactarnos para hacer alguna consulta o simplente para dejar tu comentario, por favor sientete libre de hacerlo.
                                </p>
                            </div>
                            <form name='sentMessage' validate onSubmit={handleSubmit}>
                                <div className='row'>
                                    <input
                                        type='text'
                                        id='name'
                                        name='name'
                                        className='form-control'
                                        placeholder='Nombre'
                                        required
                                        onChange={handleChange}
                                    />
                                    <p className='help-block text-danger'></p>
                                    <input
                                        type='email'
                                        id='email'
                                        name='email'
                                        className='form-control'
                                        placeholder='Correo electronico'
                                        required
                                        onChange={handleChange}
                                    />
                                    <p className='help-block text-danger'></p>
                                </div>
                                <textarea
                                    name='message'
                                    id='message'
                                    className='form-control'
                                    rows='4'
                                    placeholder='Mensaje'
                                    required
                                    onChange={handleChange}
                                ></textarea>
                                <p className='help-block text-danger'></p>
                                <div id='success'></div>
                                <button type='submit' className='btn btn-custom btn-lg'>
                                    Enviar
                                </button>
                            </form>
                        </div>
                        <div className='contact-item'>
                            <h3>Información de contacto</h3>
                            <p>
                                <span>
                                    <i className='fa fa-map-marker'></i> Dirección
                                </span>
                                {/* {props.data ? props.data.address : 'loading'} */}
                                Av. Libertador 2020
                            </p>

                            <p>
                                <span>
                                    <i className='fa fa-phone'></i> Telefono
                                </span>{' '}
                                {/* {props.data ? props.data.phone : 'loading'} */}
                                11-5555-4444
                            </p>

                            <p>
                                <span>
                                    <i class="fas fa-envelope"></i> Correo
                                </span>{' '}
                                {/* {props.data ? props.data.email : 'loading'} */}
                                hola@solucionarte.ar
                            </p>
                        </div>
                    </div>
                </div>


            </div>
        </Layout>
    )
}

export default Contact;